<aside class="al-sidebar" (mouseleave)="hoverElemTop=outOfArea" sidebarResize>
  <ul
    id="al-sidebar-list"
    class="al-sidebar-list"
    baSlimScroll
    [baSlimScrollOptions]="{height: menuHeight}"
  >
    <ba-menu-item
      *ngFor="let item of menuItems"
      [menuItem]="item"
      (itemHover)="hoverItem($event)"
      (toggleSubMenu)="toggleSubMenu($event)"
    ></ba-menu-item>
  </ul>
  <div
    class="sidebar-hover-elem"
    [ngStyle]="{top: hoverElemTop + 'px', height: hoverElemHeight + 'px'}"
    [ngClass]="{'show-hover-elem': showHoverElem }"
  ></div>
</aside>
<!-- <mat-sidenav-container>
  <mat-sidenav #sidenav mode="push">
    <p><button mat-button (click)="sidenav.toggle()">Toggle</button></p>
    <mat-sidenav-content>
      <ba-menu-item
        *ngFor="let item of menuItems"
        [menuItem]="item"
        (itemHover)="hoverItem($event)"
        (toggleSubMenu)="toggleSubMenu($event)"
      ></ba-menu-item>
    </mat-sidenav-content>
  </mat-sidenav>
</mat-sidenav-container> -->
